const formSubmit = {
  data() {
    return {
      submitting: false,
    };
  },
  methods: {
    /**
     * Submit function. Handles validation, sending request, and updating submitting state.
     * Calls success and error methods if they exist on the vm.
     * @param {Object} observer Ref object for validation observer
     * @param {String} endpoint Endpoint for request
     * @param {Object} data Data model to submit
     * @param {String} componentName Name of the component submitting (optional)
     * @param {Boolean} useDefaultAxios Use the default axios instance instead
     * of the $http configured instance
     */
    async submit(observer, action, data, componentName) {
      const isValid = await observer.validate();
      if (!isValid) {
        const firstErrorRef = Object.values(this.$refs.observer.refs).find(provider => Object.values(provider.failedRules).length);

        if (this.invalidError) {
          this.invalidError(firstErrorRef.$el);
        } else {
          const scrollContainer = document.querySelector('.wizard-tab-content') || document.querySelector('.fullContent') || document.querySelector('#app');
          this.$scrollTo(firstErrorRef.$el, {
            container: scrollContainer,
          });
        }
        this.submitting = false;
        return false;
      }

      if (!this.submitting) {
        this.submitting = true;
        return this.$store.dispatch(action, { data, submittedCallback: this.submitSuccess, componentName })
          .then(() => {
            this.submitting = false;
            return true;
          }).catch((error) => {
            this.submitting = false;
            if (this.submitError) this.submitError(error);
            return false;
          });
      }
      return false;
    },
  },
};

export default formSubmit;
